export const xmcloudLogo =
	'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/logo-xm_cloud_deploy';
export const cactusLogo =
	'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/spot-cactus-neutral';
export const checkmarkLogo =
	'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/spot-check-circle-neutral';
